import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { PageLoader } from '@lex/ui';
import { Layout } from './components/Layout';
import { useAuth } from './lib/auth';
import { ArticlePage } from './pages/ArticlePage';
import { ArticlesPage } from './pages/ArticlesPage';
import { CabinetPage } from './pages/CabinetPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { CaseDetailPage } from './pages/CaseDetailPage';
import { CasesPage } from './pages/CasesPage';
import { ChatPage } from './pages/ChatPage';
import { ErrorPage } from './pages/ErrorPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { TariffsPage } from './pages/TariffsPage';
import { ConsentPage } from './pages/legal/ConsentPage';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { TermsPage } from './pages/legal/TermsPage';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return <PageLoader />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user && !user.registrationCompleted && location.pathname !== '/register') {
    return <Navigate to="/register" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<LoginPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="consent" element={<ConsentPage />} />
        <Route path="tariffs" element={<TariffsPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="articles/:slug" element={<ArticlePage />} />
        <Route
          path="cabinet"
          element={
            <Protected>
              <CabinetPage />
            </Protected>
          }
        />
        <Route
          path="checkout"
          element={
            <Protected>
              <CheckoutPage />
            </Protected>
          }
        />
        <Route
          path="cases"
          element={
            <Protected>
              <CasesPage />
            </Protected>
          }
        />
        <Route
          path="cases/:id"
          element={
            <Protected>
              <CaseDetailPage />
            </Protected>
          }
        />
        <Route
          path="chat"
          element={
            <Protected>
              <ChatPage />
            </Protected>
          }
        />
        <Route
          path="404"
          element={
            <ErrorPage
              code="404"
              title="Страницы нет"
              text="Возможно, ссылка устарела или страница переехала. Проверьте адрес или вернитесь на главную."
            />
          }
        />
        <Route
          path="500"
          element={
            <ErrorPage
              code="500"
              title="Сбой у нас"
              text="Мы уже разбираемся. Попробуйте обновить страницу через пару минут."
            />
          }
        />
        <Route
          path="maintenance"
          element={
            <ErrorPage
              code="503"
              title="Технические работы"
              text="Сервис временно недоступен: обновляем систему. Скоро вернёмся."
            />
          }
        />
        <Route
          path="*"
          element={
            <ErrorPage
              code="404"
              title="Страницы нет"
              text="Возможно, ссылка устарела или страница переехала. Проверьте адрес или вернитесь на главную."
            />
          }
        />
      </Route>
    </Routes>
  );
}
